import dayjs from "dayjs";

const filters = {
  date: function(val, fromFormat = "YYYY-MM-DD", toFormat = "DD-MM-YY") {
    if (!val) return "";
    return dayjs(val, fromFormat).format(toFormat);
  },
  number(val, decimals = null) {
    if ([null, undefined, ""].includes(val)) return "";

    if (decimals === null) return val;

    return Number(val).toFixed(decimals);
  },
};

export default filters;
